// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__8QifT","label":"styles_label__wlumY","icon":"styles_icon__xZ07v"};